import { useState } from 'react';
import { Modal, Button } from 'semantic-ui-react'

import UpdateFeed from './UpdateFeed';

const UpdateFeedModal = ({ portalUpdates, getPortalUpdates}) => {

    const [modal, setModal] = useState(false)
    return (
        <Modal
            open={modal}
            onClose={() => setModal(false)}
            onOpen={() => setModal(true)}
            trigger={<Button size="mini" secondary>Show More +</Button>}
        >
            <Modal.Content>
                <UpdateFeed portalUpdates={portalUpdates} getPortalUpdates={getPortalUpdates}/>
            </Modal.Content>
        </Modal>
    )
}

export default UpdateFeedModal